import {
  CreateOutboundDeliveryInput,
  OutboundDeliveryItemInput,
} from "../models/autogenerated-deliveryService-gql/graphql";
import { ISavedProgress } from "../models/savedProgress";

const mapToCreateOutboundDeliveryInput = (
  savedProgress: ISavedProgress,
): CreateOutboundDeliveryInput | undefined => {
  const { outboundGeneralInfo, deliveryItems, goodsIssuePlanned } =
    savedProgress;

  if (!outboundGeneralInfo || !deliveryItems || !goodsIssuePlanned) {
    console.warn("Missing data to build createOutboundDeliveryDto");
    return;
  }

  try {
    const items: OutboundDeliveryItemInput[] = deliveryItems.map((item) => ({
      materialId: item.materialId,
      quantity: Number(item.quantity),
      unitOfMeasurement: item.unitOfMeasurement,
      batch: item.batch || undefined,
    }));

    const input: CreateOutboundDeliveryInput = {
      deliveryNumber: outboundGeneralInfo.deliveryNumber,
      locationId: outboundGeneralInfo.locationId,
      recipientBusinessPartnerNumber: outboundGeneralInfo.recipient,
      senderBusinessPartnerNumber: outboundGeneralInfo.sender || undefined,
      carrierTenantId: outboundGeneralInfo.carrierTenantId || undefined,
      goodsIssuePlanned: goodsIssuePlanned,
      deliveryDatePlanned: savedProgress.deliveryDatePlanned || undefined,
      items: items,
    };

    return input;
  } catch (error) {
    console.error("Failed to build createOutboundDeliveryInput", error);
  }
};

export { mapToCreateOutboundDeliveryInput };
